<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-sm-12 col-xs-12 col-lg-10 col-xl-9 col-xxl-9">
                <div v-if="!isLoading">
                    <ExplorerComponent ref="trackList" />
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import ExplorerComponent from '@/components/ExplorerComponent.vue';

export default {
    name: "HomeView",
    components: { ExplorerComponent },
    data() {
        return {
            isLoading: false
        }
    },
    mounted() {
        window.document.title = "demoparty"
    }
}

</script>